import React from "react";

const Gap = () => <div style={{ height: "10px" }} />;
export default Gap;
